// extracted by mini-css-extract-plugin
export default {"header":"style_header__M5AOI","title":"style_title__aTkyO","deleteButton":"style_deleteButton__MaTu5","text-preview":"style_text-preview__gDbuV"};